import { dataProvider } from "data";
import { apiMethods } from "data/api.constants";
import {
  UPDATE_ADMIN_PANEL_SETTINGS,
  GET_KEY_WISE_SETTINGS,
} from "../../constants/AdminPanel.api";
import { is_empty } from "features/Common/utils/common.utils";
import { FEATURE_STATUS } from "features/Account/Account.constants";
import { baseApiClient } from "data/modules/api/api.client";
import {
  SHOW_LISTING_RATINGS_FEATURE_KEY,
  admin_panel_setting_payload_keys,
} from "../../constants/AdminPanel.constants";

export const updateAdminPanelSettings = ({ endPoint, payload }) => {
  const apiUrl = endPoint ?? UPDATE_ADMIN_PANEL_SETTINGS;
  return baseApiClient.post(apiUrl, payload);
};

export const getKeyLevelSettings = (keys) => {
  if (is_empty(keys)) return;

  const queryString = keys.map(encodeURIComponent).join(",");
  return dataProvider.custom_request(
    `${GET_KEY_WISE_SETTINGS}?${admin_panel_setting_payload_keys.feature_keys}=${queryString}`,
    apiMethods.GET
  );
};

/**
 * Admin-panel values arrive either wrapped as `{ value }` or as a raw scalar
 * depending on the endpoint/cache path. Normalise both to a boolean.
 */
export const parse_admin_panel_setting_value = (entry) => {
  const raw =
    entry != null && typeof entry === "object" && "value" in entry
      ? entry.value
      : entry;
  return raw === true || raw === "true";
};

const get_admin_panel_settings_data = (response) =>
  response?.data?.data || response?.data || {};

export const getShowListingRatings = async () => {
  const response = await getKeyLevelSettings([
    SHOW_LISTING_RATINGS_FEATURE_KEY,
  ]);
  const data = get_admin_panel_settings_data(response);
  return parse_admin_panel_setting_value(
    data[SHOW_LISTING_RATINGS_FEATURE_KEY]
  );
};

export const updateShowListingRatings = (value) =>
  updateAdminPanelSettings({
    payload: {
      [admin_panel_setting_payload_keys.feature_key]:
        SHOW_LISTING_RATINGS_FEATURE_KEY,
      [admin_panel_setting_payload_keys.feature_value]: value,
    },
  });

/**
 * function to parse the verification status of a feature
 */
export const getSectionStates = ({ status }) => {
  const isPlanLocked = status === FEATURE_STATUS.PLAN_LOCKED;
  const verificationNotCompleted = [
    FEATURE_STATUS.ACCESS_REQUESTED,
    FEATURE_STATUS.ACCESS_DENIED,
    FEATURE_STATUS.ACCESS_LOCKED,
  ].includes(status);

  const disableSwitch = isPlanLocked || verificationNotCompleted;

  return {
    isPlanLocked,
    verificationNotCompleted,
    disableSwitch,
  };
};
